/*
    eslint-disable import/group-exports,
    func-style,
    no-magic-numbers,
    unicorn/no-null,
    unicorn/no-document-cookie,
*/
export const getCookie = function (name) {
    const version = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);

    return version ? version[2] : null;
  };

  export const setCookie = function (name, value, hours) {
    const date = new Date();

    date.setTime(date.getTime() + 60 * 60 * 1000 * hours);
    document.cookie = `${name}=${value};path=/;expires=${date.toGMTString()}`;
};
